<template>
  <b-card
  >
      <b-table
        bordered
        hover
        striped
        responsive
        :items="items"
        :fields="fields"
        class="mt-1 mb-2 position-relative"
        :busy="loading"
        :no-local-sorting="true"
        @sort-changed="sortChange"
      >
        <template #cell(Id)="row">
          <b-link
            :to="{ }"
            class="font-weight-bold"
          >
            #{{ row.value }}
          </b-link>
        </template>
        <template #cell(CreatedAt)="row">
          {{ row.value | date }}
        </template>
        <template #cell(DietDurationName)="data">
          {{ data.item.DietDurationPrice.Diet.Title }}
        </template>
        <template #cell(DietDurationPeriod)="data">
          {{ data.item.DietDurationPrice.DietDuration.Title }}
        </template>
        <template #cell(Bank)="row">
          {{ (enums('bank','value',row.value) || {}.text) }}
        </template>
        <template #cell(IsPaid)="data">
          <b-badge
              v-if="data.value"
            variant="success"
          >
             پرداخت شده
          </b-badge>
          <b-badge
              v-else
              variant="warning"
              @click="showModal(data.item)"
          >
            پرداخت نشده
          </b-badge>
        </template>
        <template #cell(Price)="data">
            {{ data.value | price }}
        </template>
        <template #cell(show_details)="row">
          <feather-icon
            :icon="row.detailsShowing? 'EyeOffIcon':'EyeIcon'"
            size="16"
            @click="row.toggleDetails"
          />
        </template>

        <template #row-details="row">
          <b-card>
            <b-row class="mb-2">
              <b-col
                md="6"
                class="mb-1"
              >
                <strong>کد پیگیری : </strong>{{ row.item.Code }}
              </b-col>
              <b-col
                md="4"
                class="mb-1"
                v-if="row.item.Coupon !== null"
              >
                <strong> عنوان کپن : </strong>{{ row.item.Coupon.Title }}
              </b-col>
            </b-row>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="row.toggleDetails"
            >
              بستن
            </b-button>
          </b-card>
        </template>
        <template #table-busy>
          <div
            class="text-center my-2"
          >
            <b-spinner
              variant="primary"
              class="align-middle"
            />
            <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
          </div>
        </template>
      </b-table>
      <z-pagination
        :per-page="5"
        :page="filterOptions.Page"
        :total-rows="totalRows"
        :loading="loading"
        @change="dietOrders"
      />

    <b-modal
        v-model="isShow"
        v-if="isShow"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        modal-class="confirm-pay-modal"
        title="تایید پرداخت"
        :no-close-on-backdrop="true"
        size="sm"
        @ok="confirmPay"
    >
      <div>
        پرداخت مورد نظر تایید شود؟
      </div>
    </b-modal>
  </b-card>
</template>
<script>
export default {

  name: 'UserDietTerms',
  props: {
    userId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      totalRows: null,
      isShow: false,
      row: null,
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'CreatedAt',
          label: 'تاریخ',
          sortable: true,
        },
        {
          key: 'DietDurationName',
          label: 'اسم دوره',
        },
        {
          key: 'DietDurationPeriod',
          label: 'مدت دوره',
        },
        {
          key: 'Bank',
          label: 'بانک',
        },
        {
          key: 'IsPaid',
          label: 'وضعیت پرداخت',
        },
        {
          key: 'Price',
          label: 'قیمت',
        },
        {
          key: 'show_details',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      filterOptions: {
        userId: this.userId,
        Page: 1,
        PerPage: 5,
        SortBy: null,
        IsDesc: true,
        Bank: [],
        DietDurationId: [],
        DietType: [],
        CouponId: [],
      },
    }
  },
  created() {
    this.dietOrders()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.dietOrders(1)
      }
    },
    dietOrders(pageNumber) {
      if (!this.$can('show', 'OrderView')) return
      this.loading = true
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$http.post(this.$api.userdietorder.getlist, this.filterOptions).then(res => {
        this.totalRows = res.totalRow
        this.items = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    editExpireDate(row) {
      this.showEditExpireDateModal = true
      this.ExpireDate = row.item.expireData
    },
    showModal(row){
      this.row = row
      this.isShow = true
    },
    confirmPay(){
      this.isShow = false
      this.$http.post(
          this.$api.userdietorder.confirmpay, {
            Id: this.row.Id,
          },
      )
          .then(res => {
            this.dietOrders()
            this.$emit('UserDietTerms')
            this.$emit('ActivityPackageOrder')
          })
    },
  },
}
</script>

<style>
  .tableActionCellWidth{
    width:500px;
  }
</style>
